import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PharmAuthorizationComponent } from './pharm-authorization.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [{ path: '**', component: PharmAuthorizationComponent, data: { title: 'Authorization' } }];

@NgModule({
  imports: [RouterModule.forChild(routes), CheckboxModule, FormsModule, ReactiveFormsModule],

  exports: [RouterModule],
})
export class PharmAuthorizationRoutingModule {}
